import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 80vh;
`;

export const StyledCanvas = styled.canvas`
  width: 100%;
  height: 80vh;
  flex: 1;
  border: 1px solid #ccc;
  cursor: pointer;
  background-color: #fffbf2;
`;

export const Menu = styled.div<{ show: boolean; x: number; y: number }>`
  position: absolute;
  top: ${({ y }) => y}px;
  left: ${({ x }) => x}px;
  display: ${({ show }) => (show ? 'block' : 'none')};
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 0;
  z-index: 1000;
  direction: rtl;
  min-width: 120px;

  div {
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-family: 'Assistant', sans-serif;
    font-size: 16px;
    text-align: right;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	img {
		width: 150px;
	}
	span {
		color: #3f3f3f;
		text-align: center;
		font-size: 40px;
		flex: 1;
	}
`;
